import { Maybe } from 'types/FMSGraphqlTypes'
import { IMotorCarrierInfoFragment } from '../graphql/MotorCarrierInfoFragment'
import { IUsersMotorCarriersQuery } from '../graphql/UsersMotorCarriers'
import { isJoinRequestPending } from './isJoinRequestPending'

/**
 * Returns an array of MotorCarriers associated to the current account and MotorCarriers with a join request.
 *
 * @example getMotorCarriersList({
 *  motorCarrierUsersForUser: [{
 *   id: '222',
 *   createdAt: '2023-03-23T15:20:18Z',
 *   motorCarrier: { id: '123' }
 *  }],
 *  motorCarrierJoinRequestsForUser: [{
 *    id: '111',
 *    motorCarrier: { id: '456' }
 *  }]
 * }) // [{ id: '123' }, { id: '456' }]
 */
export const getMotorCarriersList = (
  userMotorCarriersData: Maybe<IUsersMotorCarriersQuery>
): IMotorCarrierInfoFragment[] => {
  if (!userMotorCarriersData) {
    return []
  }

  const {
    motorCarrierJoinRequestsForUser: joinRequests = [],
    motorCarrierUsersForUser: motorCarrierUsers,
  } = userMotorCarriersData || {}

  const motorCarriers: IMotorCarrierInfoFragment[] = motorCarrierUsers.map(
    motorCarrierUser => motorCarrierUser.motorCarrier
  )

  const joinRequestsMotorCarriers: IMotorCarrierInfoFragment[] =
    joinRequests
      ?.map(joinRequest => joinRequest.motorCarrier)
      .filter(({ id: motorCarrierId }) => isJoinRequestPending({ joinRequests, motorCarrierId })) ||
    []

  return [...motorCarriers, ...joinRequestsMotorCarriers]
}
